import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";


// Verificar si un estudiante tiene acceso a sus notas
export const verificarAccesoEstudianteNotas = async (studentId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/notas-visibilidad/verificar/${studentId}`,
    { headers }
  );
  return response.data;
};

// Verificar si un estudiante tiene acceso a un periodo específico
export const verificarAccesoPeriodoNotas = async (studentId, periodoId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/notas-visibilidad/verificar/${studentId}/${periodoId}`,
    { headers }
  );
  return response.data;
};

// Obtener lista de inhabilitaciones activas
export const getInhabilitadosNotas = async () => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/notas-visibilidad/inhabilitados`,
    { headers }
  );
  return response.data;
};

// Gestionar visibilidad (habilitar/inhabilitar)
export const gestionarVisibilidadNotas = async (data) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.post(
    `${API_BASE_URL}/notas-visibilidad/gestionar`,
    data,
    { headers }
  );
  return response.data;
};

export const getNotasByStudent = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(
    `${API_BASE_URL}/notas/estudiante`,
    { headers }
  );
  return response.data.data;
};

export const getNotasByAsignatura = async (asignaturaId) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(
    `${API_BASE_URL}/notas/asignatura/${asignaturaId}`,
    { headers }
  );
  return response.data;
};

export const getNotasForAdmin = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };

  const response = await axios.get(`${API_BASE_URL}/notas/rector`, { headers });
  return response.data.data; // Asegúrate de que el backend retorna los datos en esta estructura
};


export const getNotasByDirector = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/notas/director`, {
    headers,
  });
  return response.data.data;
};

export const getPeriodos = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/notas/periodos`, { headers });
  return response.data.data;
};


export const createNota = async (notaData) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(`${API_BASE_URL}/notas`, notaData, {
    headers,
  });
  return response.data;
};

export const updateNota = async (notaId, notaData) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.put(
    `${API_BASE_URL}/notas/${notaId}`,
    notaData,
    { headers }
  );
  return response.data;
};

export const editarMotivo = async (motivoId, nuevoNombre) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.put(
    `${API_BASE_URL}/notas/motivos/${motivoId}`,
    { nombre: nuevoNombre },
    { headers: { Authorization: `${token}` } }
  );
  return response.data;
};


export const deleteNota = async (id) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.delete(`${API_BASE_URL}/notas/eliminar/${id}`, {
    headers,
  });
  return response.data;
};

export const guardarNotasMasivas = async (data) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(
    `${API_BASE_URL}/notas/masiva`, 
    data,
    { headers }
  );
  return response.data;
};

export const obtenerPlanillaNotas = async (salonId, periodoId, asignaturaSalonId) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(
    `${API_BASE_URL}/notas/planilla`, 
    { 
      params: { salon_id: salonId, periodo_id: periodoId, asignatura_salon_id: asignaturaSalonId },
      headers
    }
  );
  return response.data;
};

export const obtenerMotivos = async (salonId, periodoId, asignaturaSalonId) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.get(
    `${API_BASE_URL}/notas/motivos`,
    {
      params: { salon_id: salonId, periodo_id: periodoId, asignatura_salon_id: asignaturaSalonId },
      headers: { Authorization: token }
    }
  );
  return response.data;
};

export const agregarMotivo = async (data) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.post(
    `${API_BASE_URL}/notas/motivos`,
    data,
    { headers: { Authorization: token } }
  );
  return response.data;
};

export const eliminarMotivo = async (motivoId) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.delete(
    `${API_BASE_URL}/notas/motivos/${motivoId}`,
    { headers: { Authorization: token } }
  );
  return response.data;
};

export const obtenerPlanillaConMotivos = async (salonId, periodoId, asignaturaSalonId) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.get(
    `${API_BASE_URL}/notas/planilla-motivos`,
    {
      params: { salon_id: salonId, periodo_id: periodoId, asignatura_salon_id: asignaturaSalonId },
      headers: { Authorization: token }
    }
  );
  return response.data;
};

export const guardarCalificacionesMotivos = async (calificaciones) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.post(
    `${API_BASE_URL}/notas/calificaciones-motivos`,
    { calificaciones },
    { headers: { Authorization: token } }
  );
  return response.data;
};

// ✅ MODIFICAR: Obtener asignaturas del salón con sus asignatura_salon_id
export const obtenerAsignaturasSalon = async (salonId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  
  const response = await axios.get(
    `${API_BASE_URL}/notas/asignaturas-salon/${salonId}`,
    { headers }
  );
  return response.data;
};

// ✅ NUEVA: Verificar si una asignatura está configurada para un salón
export const verificarAsignaturaSalon = async (salonId, asignaturaId) => {
  const token = localStorage.getItem("authToken");
  const response = await axios.get(
    `${API_BASE_URL}/notas/verificar-asignatura/${salonId}/${asignaturaId}`,
    { headers: { Authorization: token } }
  );
  return response.data;
};
